import axios from './configAxios';

export const putTerminal = async (id, requestData) => {
  return await axios.put(`/${id}/update/`, requestData);
};
